import { UserAction, userActionTypeEnum } from '@thoughtspot/metrics';
export var PageContext;
(function (PageContext) {
    PageContext["INTENT_PAGE"] = "Intent page";
    PageContext["AGENT_SELECTION_PAGE"] = "Agent selection page";
    PageContext["BUILD_PAGE"] = "Build page";
    PageContext["USE_CASE_SELECTION_PAGE"] = "UseCase selection page";
})(PageContext || (PageContext = {}));
export const buildPageLoaded = (metricsService, selectedFunction, selectedIndustry) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.BUILD_PAGE_LOADED), {
        pageContext: PageContext.BUILD_PAGE,
        selectedFunction,
        selectedIndustry,
    });
};
export const buildInfoChanged = (metricsService, selectedFunction, selectedIndustry) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.BUILD_INFO_CHANGED), {
        pageContext: PageContext.BUILD_PAGE,
        selectedFunction,
        selectedIndustry,
    });
};
export const buildPageErrorShown = (metricsService, selectedFunction, selectedIndustry, errorType) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.BUILD_PAGE_ERROR_SHOWN), {
        pageContext: PageContext.BUILD_PAGE,
        selectedFunction,
        selectedIndustry,
        errorType,
    });
};
export const buildCompleted = (metricsService, selectedFunction, selectedIndustry) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.BUILD_COMPLETED), {
        pageContext: PageContext.BUILD_PAGE,
        selectedFunction,
        selectedIndustry,
    });
};
export const buildScreenCtaClicked = (metricsService, selectedFunction, selectedIndustry) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.BUILD_SCREEN_CTA_CLICKED), {
        pageContext: PageContext.BUILD_PAGE,
        selectedFunction,
        selectedIndustry,
    });
};
export const previewDataScrolled = (metricsService, selectedFunction, selectedIndustry) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.PREVIEW_DATA_SCROLLED), {
        pageContext: PageContext.BUILD_PAGE,
        selectedFunction,
        selectedIndustry,
    });
};
export const agentSelectionPageErrorShown = (metricsService, properties) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.AGENT_SELECTION_PAGE_ERROR_SHOWN), properties);
};
export const agentCardClicked = (metricsService, properties) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.AGENT_CARD_CLICKED), properties);
};
export const agentSelectionConfirmed = (metricsService, properties) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.AGENT_SELECTION_CONFIRMED), properties);
};
export const agentSelectionPageLoaded = (metricsService, properties) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.AGENT_SELECTION_PAGE_LOADED), properties);
};
export const intentPageLoaded = (metricsService, properties) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.INTENT_PAGE_LOADED), properties);
};
export const intentOptionsOpened = (metricsService, properties) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.INTENT_OPTIONS_OPENED), properties);
};
export const intentOptionSelected = (metricsService, properties) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.INTENT_OPTION_SELECTED), properties);
};
export const intentSelectionConfirmed = (metricsService, properties) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.INTENT_SELECTION_CONFIRMED), properties);
};
export const intentPageErrorShown = (metricsService, properties) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.INTENT_PAGE_ERROR_SHOWN), properties);
};
export const usecaseSelectionPageLoaded = (metricsService, properties) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.USECASE_SELECTION_PAGE_LOADED), properties);
};
export const usecaseCardClicked = (metricsService, properties) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.USECASE_CARD_CLICKED), properties);
};
export const usecaseSelectionConfirmed = (metricsService, properties) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.USECASE_SELECTION_CONFIRMED), properties);
};
export const usecasePageErrorShown = (metricsService, properties) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.USECASE_PAGE_ERROR_SHOWN), properties);
};
//# sourceMappingURL=metrics-utils.js.map